/** Scroll past this to use compact hero bottom padding while the promo banner is visible. */
export const HERO_SCROLL_COMPACT_THRESHOLD_PX = 40

export function nextHeroScrollCompactState(
  currentCompact: boolean,
  scrollY: number,
): boolean {
  if (!currentCompact && scrollY > HERO_SCROLL_COMPACT_THRESHOLD_PX) {
    return true
  }

  if (currentCompact && scrollY <= HERO_SCROLL_COMPACT_THRESHOLD_PX) {
    return false
  }

  return currentCompact
}

export function getEffectiveHeroScrollY(
  lenisScroll: number | undefined,
  windowScrollY: number,
  documentScrollTop?: number,
): number {
  const nativeScrollY =
    documentScrollTop === undefined
      ? windowScrollY
      : Math.min(windowScrollY, documentScrollTop)

  if (lenisScroll === undefined) {
    return nativeScrollY
  }

  return Math.min(lenisScroll, nativeScrollY)
}
